import './InlineEditor.less';
import React from 'react';
import __ from "../../../i18n";
import Request from "../../../../bootstrap/api/Request";
import AudioUpdateParcel from "../../../api/endpoints/audio/AudioUpdateParcel";
import Toasts, {TOAST_SUCCESS} from "../../../../bootstrap/scomponents/toasts/Toasts";
import CustomForm from "../../../../bootstrap/components/custom-form/CustomForm";


export default function InlineEditor({item, updateItem, close}) {

    return <div className="inline-editor">
        <CustomForm
            fieldsConfig={{
                title: {
                    name: __('Title'),
                    type: 'text',
                    defaultValue: item.title,
                    rules: {
                        required: true
                    }
                }
            }}
            layoutConfig={['title']}
            submit={(values, onSuccess, onError) => {
                Request.add(new AudioUpdateParcel(item.id, values))
                    .then(() => {
                        onSuccess();
                        Toasts.add(TOAST_SUCCESS, __('Your changes have been saved successfully'));
                        updateItem(item.id, values);
                        close();
                    })
                    .catch(error => {
                        onError(error.getMessage());
                    });
            }}
        />
    </div>;
}
